import Vue from 'vue'
import Vuex from 'vuex'
import { getProfile } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('bajj_token') || '',
    profile: null,
    customerServiceUrl: localStorage.getItem('bajj_cs_url') || '',
    websiteHomeUrl: localStorage.getItem('bajj_website_url') || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('bajj_token', token)
    },
    SET_PROFILE(state, profile) {
      state.profile = profile
    },
    SET_CS(state, url) {
      state.customerServiceUrl = url || ''
      if (url) localStorage.setItem('bajj_cs_url', url)
      else localStorage.removeItem('bajj_cs_url')
    },
    SET_WEBSITE(state, url) {
      state.websiteHomeUrl = url || ''
      if (url) localStorage.setItem('bajj_website_url', url)
      else localStorage.removeItem('bajj_website_url')
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.profile = null
      localStorage.removeItem('bajj_token')
    }
  },
  actions: {
    async fetchProfile({ commit }) {
      const res = await getProfile()
      commit('SET_PROFILE', res.data)
      return res.data
    }
  }
})
